import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useForm } from "react-hook-form";
import { joiResolver } from "@hookform/resolvers/joi";
import { get, size } from "lodash";
import {
  Button,
  Grid,
  Typography,
  TextField,
  Stack,
  Divider,
  FormControlLabel,
  Checkbox,
  IconButton,
  Chip,
} from "@mui/material";
import { useSnackbar } from "notistack";
import AddAPhotoIcon from "@mui/icons-material/AddAPhoto";
import Iconify from "../../components/iconify/iconify";
import CustomPopover from "../../components/custom-popover/custom-popover";
import usePopover from "../../components/custom-popover/use-popover";
import { Box } from "@mui/system";
import { useDoctorForm } from "../../data/talons/Doctor/useDoctorForm";
import { color } from "../../utils/constant";
import { useFaqForm } from "../../data/talons/Faq/useFaqForm";
import useFaq from "../../data/talons/Faq/useFaq";
import { getFaqData } from "../../data/selectors/Faq/FaqForm.selector";
import { getDoctorList } from "../../data/selectors/Faq/Faq.selector";
import RHFAutocomplete from "../../components/shared/RHFAutocomplete";
import { useSelector } from "react-redux";

export default function FaqForm(props) {
  const { enqueueSnackbar } = useSnackbar();
  const { fetchDoctorComboList } = useFaq();
  const editItem = useSelector(getFaqData);
  const doctorList = useSelector(getDoctorList);

  const {
    loader,
    loading,
    status,
    faqEntrySchema,
    handleStatusComboChange,
    faqEntry,
    faqUpdate,
    findDoctorFromLabel,
    DoctorId,
  } = useFaqForm({
    existingStatus: get(editItem, "status", 0),
    existingDoctorName: get(editItem, "doctor_id", ""),
  });
  useEffect(() => {
    fetchDoctorComboList();
  }, []);

  const defaultValues = useMemo(() => ({
    name: get(editItem, "name", ""),
    question: get(editItem, "question", ""),
    answer: get(editItem, "answer", ""),
  }));
  const {
    register,
    handleSubmit,
    formState: { errors },
    getValues,
    control,
    setValue,
  } = useForm({
    resolver: joiResolver(faqEntrySchema),
    defaultValues,
  });
  const onUserSubmit = useCallback(async () => {
    try {
      const res =
        get(editItem, "id", null) === null
          ? await faqEntry({
              ...getValues(),
            })
          : await faqUpdate({
              ...getValues(),
              id: get(editItem, "id", null),
            });

      if (res === true) {
        props.postSubmit();
      }
    } catch (err) {
      console.log("errr", err);
    }
  }, [faqEntry]);

  return (
    <React.Fragment>
      <Typography variant="h5" gutterBottom>
        FAQ Form
      </Typography>
      <Divider sx={{ mb: 3 }} />
      <Grid container spacing={2}>
        <Grid item xs={12} sm={12} md={12}>
          <RHFAutocomplete
            borderRadius={"0px"}
            isRequired={true}
            name="name"
            label="Doctor Name"
            freeSolo
            data={doctorList || []}
            defaultValue={DoctorId}
            onInputChange={(value) => findDoctorFromLabel(value)}
            id={doctorList?.map((option) => option.id)}
            renderOption={(props, option) => (
              <>
                <li {...props} key={option}>
                  {option}
                </li>
              </>
            )}
            renderTags={(selected, getTagProps) =>
              selected.map((option, index) => (
                <Chip
                  {...getTagProps({ index })}
                  key={option}
                  label={option}
                  size="small"
                  color="info"
                  variant="soft"
                />
              ))
            }
            control={control}
            setValue={setValue}
          />
        </Grid>
        <Grid item xs={12} sm={12}>
          <TextField
            required
            id="question"
            name="question"
            label="Question"
            fullWidth={true}
            multiline
            variant="outlined"
            size="small"
            inputProps={{
              //maxLength: 50,
            }}
            {...register("question")}
            autoComplete="false"
            error={size(errors?.question?.message) > 0 ? true : false}
            helperText={
              size(errors?.question?.message) > 0
                ? errors?.question?.message
                : ""
            }
          />
        </Grid>
        <Grid item xs={12} sm={12}>
          <TextField
            required
            id="answer"
            name="answer"
            label="Answer"
            fullWidth={true}
            variant="outlined"
            multiline
            size="small"
            inputProps={{
             // maxLength: 50,
            }}
            {...register("answer")}
            autoComplete="false"
            error={size(errors?.answer?.message) > 0 ? true : false}
            helperText={
              size(errors?.answer?.message) > 0 ? errors?.answer?.message : ""
            }
          />
        </Grid>

        <Grid item xs={3} sm={3}>
          <Typography>
            <FormControlLabel
              sx={{ mt: -1 }}
              control={
                <Checkbox
                  sx={{
                    "&.Mui-checked": {
                      color: color.button,
                    },
                  }}
                  id="is_labour"
                  checked={status}
                />
              }
              label="Active"
              onChange={handleStatusComboChange}
            />
          </Typography>
        </Grid>
        <Grid container direction="row">
          <Grid item xs={12} sm={12}>
            <Stack direction="row" justifyContent="end">
              <Button
                variant="contained"
                sx={{
                  height: 40,
                  borderRadius: 3,
                  m: 1,
                  backgroundColor: color.button,
                  "&:hover": {
                    backgroundColor: color.button,
                  },
                }}
                type="submit"
                onClick={(e) => {
                  e.preventDefault();
                  handleSubmit(onUserSubmit)();
                }}
              >
                Save
              </Button>
              <Button
                sx={{
                  height: 40,
                  borderRadius: 3,
                  m: 1,
                  borderColor: color.button,
                  color: color.button,
                  "&:hover": {
                    color: color.button,
                  },
                }}
                variant="outlined"
                onClick={(e) => {
                  e.preventDefault();
                  props.postSubmit();
                }}
              >
                Cancel
              </Button>
            </Stack>
          </Grid>
        </Grid>
      </Grid>
    </React.Fragment>
  );
}
